export const NAME = 'search-bar';
